module.exports = __webpack_public_path__ + "static/picnic-i-2005-0afbf8374d772fc53a0010864959a7f6.jpg";